import useMixApplyCalcs from 'hooks/useMixApplyCalcs';

import type { MixRecipe, RateOverrides, TankStateFixture } from 'pages/MixApplyPage/types';

type Props = {
    mixRecipe: MixRecipe | null;
    rateOverrides: RateOverrides;
    tankState: TankStateFixture;
    totalAcres: number;
};

const useMixApplyPageCalcs = ({ mixRecipe, rateOverrides, tankState, totalAcres }: Props) =>
    useMixApplyCalcs({
        appTankGal: tankState.appTankGal,
        carrierRateGalPerAc: tankState.carrierRateGalPerAc,
        mixTankGal: tankState.mixTankGal,
        products:
            mixRecipe?.products.map(product => ({
                densityLbPerGal: product.densityLbPerGal ?? null,
                productId: product.productId,
                productName: product.productName,
                rate: rateOverrides[product.productId] ?? product.rate,
                rateUnit: product.rateUnit
            })) ?? [],
        totalAcres
    });

export default useMixApplyPageCalcs;
